import React, { useEffect } from "react";
import "../../Assets/Styles/pages/landingRedesign.scss";
import "../../Assets/Styles/pages/pricingPageRedesign.scss";
import Nav from "../../Components/LandingComponents/Nav";
import Refund from "../../Components/RefundComponents/refund";
import usePageMetadata from "../../Utils/usePageMetadata";
import { useTranslation } from "react-i18next";

const RefundPolicy: React.FC = () => {
  const { t } = useTranslation();

  usePageMetadata(
    "Refund Policy - eZy WaterMark",
    "Review our subscription cancellation and refund policies. Find terms regarding monthly & yearly plans and mobile store purchases."
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-redesign">
      <Nav />
      <section className="pp-hero lr-grain">
        <div className="pp-hero__orbs">
          <div className="pp-hero__orb pp-hero__orb--1" />
          <div className="pp-hero__orb pp-hero__orb--2" />
        </div>

        <div className="pp-hero__content">
          <span className="pp-hero__badge">
            <span />
            {t("RefundTitle")}
          </span>
          <h1 className="pp-hero__title">
            <span className="lr-hero-word" style={{ animationDelay: "0.05s" }}>
              <span className="lr-text-gradient">Cancellation &</span>
            </span>{" "}
            <span className="lr-hero-word" style={{ animationDelay: "0.2s" }}>
              <span className="lr-text-gradient">Refunds</span>
            </span>
          </h1>
          <p className="pp-hero__subtitle">Clear rules on subscriptions, billing, and cancellations.</p>
        </div>
      </section>
      <Refund />
    </div>
  );
};

export default RefundPolicy;
